import { SUBSCRIPTION_SERVICE } from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_USER_PROFILE = `${SUBSCRIPTION_SERVICE}/userprofile`;

export const userProfile = {
  get: async (oid, domain) => {
    const options = await apiOptions({
      url: `${API_USER_PROFILE}?&oid=${oid}&mip_domain=${domain}`,
      method: "get",
    });
    return apiRequest(options);
  },
};
